import { initReactQueryAuth } from 'react-query-auth';

import { Spinner } from '@/components/Elements';
import { GOOGLE_CLIENT_ID, APP_PATH, SCOPE } from '@/config';
import { isMobile, isEmbedded } from 'react-device-detect';
import {
  loginWithGoogle,
  saveFCMToken,
  getUser,
  registerWithEmailAndPassword,
  UserResponse,
  LoginCredentialsDTO,
  RegisterCredentialsDTO,
  AuthUser,
  loginWithEmailId,
} from '@/features/auth';
import storage from '@/utils/storage';
import appCompoLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
async function handleUserResponse(data: UserResponse) {
  if (data.token) {
    storage.setToken(`Bearer ${data.token}`);
    storage.setKey('activeLocationId', data.activeLocationId);
  }

  return data;
}

async function loadUser() {
  if (storage.getToken()) {
    const data = await getUser();
    return data;
  }
  return null;
}

async function loginFn(data: LoginCredentialsDTO) {
  let response = {} as UserResponse;
  if (data.userData) {
    response = data.userData;
  } else {
    if (data?.password || data?.otp) {
      try {
        response = await loginWithEmailId(data);
      } catch (error) {
        console.log("error", error)
      }
    } else {
      response = await loginWithGoogle(data);
    }
  }
  if (response) {
    if (response && response?.email) {
      const user = await handleUserResponse(response);
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('petskedapp') < 0 && userAgent.indexOf('Your App Info/Version') < 0) {
        saveFCMToken();
      }
      return user;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

async function registerFn(data: RegisterCredentialsDTO) {
  const response = await registerWithEmailAndPassword(data);
  const user = await handleUserResponse(response);
  return user;
}

async function logoutFn() {
  storage.clearToken();
  storage.clearSAToken();
  window.location.assign((window.location.origin + APP_PATH) as unknown as string);
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Lottie className="hw-60" animationData={appCompoLoading} />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>(authConfig);
